import { PrintService } from './print.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.print', [])
  .service('printService', PrintService).name;
